(function () {
    'use strict';

    angular.module("imApp").factory("productCompositionsService", ['$ihttp', function ($ihttp) {
        let service = {
            listProductCompositions: function (parms) {
                return $ihttp.post({
                    method: 2706,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
